import { useMemo } from "react";

import { getGuidanceStage } from "@/lib/guidance/disclosure";
import { useStore } from "@/store/store";

export function useGuidanceStage() {
  const companies = useStore((state) => state.companies);
  const guidanceState = useStore((state) => state.guidanceState);
  const isGuidanceHydrated = useStore((state) => state.isGuidanceHydrated);

  const stage = useMemo(
    () => getGuidanceStage({ companies, guidanceState }),
    [companies, guidanceState]
  );

  return { stage, isGuidanceHydrated };
}
